module.exports = __webpack_public_path__ + "static/jellyfish-80de868eac49effedfbbdeab0a8256ac.jpg";